/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCodeInterpreterCallInterpretingEvent = {
  type: "response.code_interpreter_call.interpreting";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseCodeInterpreterCallInterpretingEvent$inboundSchema:
  z.ZodType<
    ResponseCodeInterpreterCallInterpretingEvent,
    z.ZodTypeDef,
    unknown
  > = z.object({
    type: z.literal("response.code_interpreter_call.interpreting"),
    sequence_number: z.number().int(),
    item_id: z.string(),
    output_index: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "sequence_number": "sequenceNumber",
      "item_id": "itemId",
      "output_index": "outputIndex",
    });
  });
/** @internal */
export type ResponseCodeInterpreterCallInterpretingEvent$Outbound = {
  type: "response.code_interpreter_call.interpreting";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseCodeInterpreterCallInterpretingEvent$outboundSchema:
  z.ZodType<
    ResponseCodeInterpreterCallInterpretingEvent$Outbound,
    z.ZodTypeDef,
    ResponseCodeInterpreterCallInterpretingEvent
  > = z.object({
    type: z.literal("response.code_interpreter_call.interpreting"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseCodeInterpreterCallInterpretingEventToJSON(
  responseCodeInterpreterCallInterpretingEvent:
    ResponseCodeInterpreterCallInterpretingEvent,
): string {
  return JSON.stringify(
    ResponseCodeInterpreterCallInterpretingEvent$outboundSchema.parse(
      responseCodeInterpreterCallInterpretingEvent,
    ),
  );
}
export function responseCodeInterpreterCallInterpretingEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseCodeInterpreterCallInterpretingEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCodeInterpreterCallInterpretingEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseCodeInterpreterCallInterpretingEvent' from JSON`,
  );
}
